// extracted by mini-css-extract-plugin
export default {"app-footer":"footer_app-footer__95cnI","main":"footer_main__UzahU"};